'use client';

import { useState } from 'react';
import Image from 'next/image';
import { Modal } from '@/components/Modal';
import { Zoomable } from '@/components/Zoomable/Zoomable';
import type { CmsFleetCategoryFloorPlan } from '@/services/cms-sdk/schemas/models/CmsFleetCategoryFloorPlan';

export interface FleetCategoryFloorPlanImageProps {
    floorPlan: CmsFleetCategoryFloorPlan;
    openInModal?: boolean;
}

export function FleetCategoryFloorPlanImage({ floorPlan, openInModal = false }: FleetCategoryFloorPlanImageProps) {
    const [open, setOpen] = useState(false);
    const image = <Image src={floorPlan.url} alt={floorPlan.name} fill={true} className="object-contain" />;
    const box = <div className="w-75 h-140 relative bg-base-150 rounded-2xl mb-6">{image}</div>;

    if (!openInModal) {
        return box;
    }

    return (
        <>
            <button type="button" className="cursor-zoom-in" aria-label={floorPlan.name} onClick={() => setOpen(true)}>
                {box}
            </button>
            <Modal
                className="[&_.modal-box]:p-0 [&_.modal-box]:h-[calc(100dvh-1rem)] [&_.modal-box]:w-[calc(100%-1rem)] [&_.modal-box]:bg-black [&_.modal-box]:rounded-md [&_.modal-box]:overflow-hidden"
                open={open}
                onClose={() => setOpen(false)}
                showClose={true}
            >
                <Zoomable controls={true}>
                    <div className="relative w-[calc(100vw-1rem)] h-[calc(100dvh-1rem)]">{image}</div>
                </Zoomable>
            </Modal>
        </>
    );
}
